(function ($, Drupal) {

  Drupal.behaviors.initWechat = {
    attach: function (context, settings) {

      $('.social__menu-item', context).once('initWechat').each(function () {

        let $socialLink = $(this),
          $wechat = $socialLink.find('.social__link--wechat'),
          $wcTooltip = $socialLink.find('.footer__wechat').addClass('is-hidden');

        $wechat.on('click', function(evt) {
          evt.preventDefault();
          $wcTooltip.toggleClass('is-hidden');
        });

      });

    }
  };

})(jQuery, Drupal);
